module.exports = __webpack_public_path__ + "img/Payssion.1f0e9af9.png";